<script lang="ts" setup>
</script>

<template>
    <v-app>
        <v-container class="main-container">
            <SystemBar />
            <Navigation />

            <v-main>
                <v-container fluid>
                    <RouterView />
                </v-container>
            </v-main>
        </v-container>
        <GlobalNotifications />
    </v-app>
</template>

<style scoped>
    .main-container {
        max-width: 2400px;
        margin: 0 auto;
        padding: 16px;
        background-color: #f4f4f9;
        min-height: 100dvh;
    }
</style>
